<picture>
  @if (convertToWebp) {
    <source [srcset]="webpSrc" type="image/webp" />
  } @else {
    <source [srcset]="src" />
  }
  <img [src]="src" [alt]="alt" />
</picture>
